@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.flexRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.chartTitleLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.styledButton {
  color: var(--text-primary);
}
